import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type HealthSnapshot } from '../../api/observability';

function HealthList({ title, items }: { title: string; items: HealthSnapshot['dependencies'] }) {
  if (!items?.length) return null;
  return (
    <div className="mt-6">
      <h2 className="text-lg font-medium">{title}</h2>
      <ul className="mt-2 divide-y rounded-lg border dark:border-slate-700">
        {items.map((d) => (
          <li key={d.name} className="flex items-center justify-between px-4 py-2 text-sm">
            <span>{d.name} <span className="text-slate-500">({d.type})</span></span>
            <span className={`capitalize ${d.status === 'healthy' ? 'text-green-600' : d.status === 'degraded' ? 'text-yellow-600' : 'text-red-600'}`}>
              {d.status} · {d.latency_ms}ms
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function HealthDashboardPage() {
  const [health, setHealth] = useState<HealthSnapshot | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.health().then(setHealth).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Health Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {health && (
        <>
          <p className="mt-2 text-lg capitalize">Overall: <strong className={health.overall === 'healthy' ? 'text-green-600' : 'text-yellow-600'}>{health.overall}</strong></p>
          <HealthList title="Services" items={health.dependencies} />
          <HealthList title="Queues" items={health.queues} />
          <HealthList title="Databases" items={health.databases} />
          <HealthList title="Caches" items={health.caches} />
          <HealthList title="Providers" items={health.providers} />
          <HealthList title="Marketplaces" items={health.marketplaces} />
        </>
      )}
    </div>
  );
}
